import { render, staticRenderFns } from "./RepassesDoDia.vue?vue&type=template&id=5f97ac42&"
import script from "./RepassesDoDia.vue?vue&type=script&lang=js&"
export * from "./RepassesDoDia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports